import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'

// Connects to data-controller="schedule-entries--search"
export default class extends Controller {
  static values = { delay: Number }
  static outlets = ["schedule-entries--week-calendar"]

  connect() {
    this.timeout = null
  }

  submitForm() {

    let input = this.element.querySelector('input[name="week_start"]')
    if (!input) {
      input = document.createElement('input')
      Object.assign(input, { type: 'hidden', name: 'week_start' })
      this.element.appendChild(input)
    }

    if (this.scheduleEntriesWeekCalendarOutlet) {
      const weekStart = this.scheduleEntriesWeekCalendarOutlet.getCurrentWeekStart()
      input.value = weekStart.toISOString().split('T')[0]
    }

    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue || 0)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  resetForm(event) {
    event.preventDefault()

    alert("保存しました。")

    this.element.reset()
    const url = new URL(window.location.href);

    if (this.scheduleEntriesWeekCalendarOutlet) {
      const currentWeekStart = this.scheduleEntriesWeekCalendarOutlet.getCurrentWeekStart()
      const dateStr = currentWeekStart.toISOString().split('T')[0]
      url.searchParams.set('week_start', dateStr)
    }
    Turbo.visit(url, { frame: "schedule_entries" })
  }

  async deleteAllEntries(event) {
    event.preventDefault()

    if (!confirm("本当に全ての予定を削除しますか？")) {
      return
    }

    const formData = new FormData(this.element)
    const url = new URL(this.element.dataset.bulkDestroyUrl, window.location.origin);

    if (this.scheduleEntriesWeekCalendarOutlet) {
      const currentWeekStart = this.scheduleEntriesWeekCalendarOutlet.getCurrentWeekStart()
      const dateStr = currentWeekStart.toISOString().split('T')[0]
      url.searchParams.set('week_start', dateStr)
    }

    try {
      await post(url.toString(), {
        body: formData,
        responseKind: 'turbo-stream'
      })
    } catch (error) {
      console.error("There was a problem with the delete operation:", error)
      alert("エントリの削除中にエラーが発生しました。")
    }
  }
}
